<script>
import convertToHtml from '@rei/rich-text-renderer';

export default {
  name: 'GiftcardDonationComponent',
  props: {
    disclaimer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    disclaimerHTML() {
      return convertToHtml(this.disclaimer);
    },
  },
};
</script>

<template>
  <section class="container-static">
    <div
      v-if="disclaimerHTML"
      id="disclaimer"
      class="giftcard-donation__disclaimer"
      data-ui="gift-card-donation-information"
      v-html="disclaimerHTML"
    />
  </section>
</template>
